import { ActionVisibilityValueType } from 'utils/adl-services';
import { OPTION_TYPES } from '../constants';

export const getType = (valueType) => {
  switch (valueType) {
    case ActionVisibilityValueType.Answer:
      return OPTION_TYPES.ANSWER;
    case ActionVisibilityValueType.Row:
      return OPTION_TYPES.ROW;
    case ActionVisibilityValueType.Column:
      return OPTION_TYPES.COLUMN;
    case ActionVisibilityValueType.Node:
      return OPTION_TYPES.NODE;
    default:
      return OPTION_TYPES.ANSWER;
  }
};

function getPrefix(valueType) {
  switch (valueType) {
    case ActionVisibilityValueType.Node:
      return 'unconditional-hide-node';
    default:
      return 'unconditional-hide-answer';
  }
}

export function getDataTestId(valueType, testId) {
  return `${getPrefix(valueType)}-${testId}`;
}
